import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoAst: CultureInfo = {
  name: 'ast',
  displayName: 'asturianu',
  iso3LanguageCode: 'ast',
  iso2LanguageCode: 'ast',
  ietfLanguageTag: 'ast',
  parent: null
};
